<template>
  <div v-show="getShow">
    <div class="enter-x min-w-64 min-h-64">
      <div id="wxlogin" class="flex justify-center"></div>
      <a-button
        size="large"
        block
        class="mt-4 enter-x"
        @click="handleBackLogin"
      >
        返回
      </a-button>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      login_loading: false,
    };
  },
  computed: {
    ...mapState('user', ['loginState']),
    getShow() {
      return this.loginState == 'QR_CODE';
    },
  },
  watch: {
    getShow(a) {
      if (a) {
        window.WxLogin({
          id: 'wxlogin',
          appid: 'wx0475cfc629e1f77b',
          scope: 'snsapi_login',
          redirect_uri: encodeURIComponent('https://yl.jdbsk.com/#/login'),
        });
      }
    },
  },
  methods: {
    handleBackLogin(type) {
      this.$store.commit('user/SET_LOGINSTATE', { state: 'PASSWORD' });
    },
  },
};
</script>
